import api from './api'

export const authService = {
  // surface: 'internal' | 'partner' — hangi giriş ekranından geldiği. Sunucu
  // partner kapısında iç hesabı, iç kapıda partner hesabını reddeder.
  login: async (username, password, surface) => {
    const response = await api.post('/auth/login', {
      username,
      password,
      ...(surface ? { surface } : {}),
    })
    return response.data // { access_token, refresh_token, user }
  },

  refresh: async (refreshToken) => {
    const response = await api.post('/auth/refresh', {
      refresh_token: refreshToken,
    })
    return response.data // { access_token, refresh_token }
  },

  getMe: async () => {
    const response = await api.get('/auth/me')
    return response.data // { user: {...} }
  },

  // ⚠️ new_password_confirm ZORUNLU (models/auth.ChangePasswordRequest) — eksikse 422.
  // Ekran hiç yazılmadığı için bu çağrı bugüne kadar hiç kullanılmamıştı.
  changePassword: async (oldPassword, newPassword, confirmPassword) => {
    const response = await api.put('/auth/change-password', {
      old_password: oldPassword,
      new_password: newPassword,
      new_password_confirm: confirmPassword ?? newPassword,
    })
    return response.data
  },

  // Kendi profilini güncelle (e-posta) — merkezi rpt_auth_user, tekliflerde otomatik kullanılır
  updateProfile: async (payload) => {
    const response = await api.put('/auth/profile', payload)
    return response.data // { message, email }
  },

  logout: async () => {
    try {
      await api.post('/auth/logout')
    } catch (error) {
      console.error('Logout error:', error)
    }
  },
}
